import {icon} from 'app/icons';
import {customPopup, customOptions} from 'app/popup';
import {layers} from 'app/layers';
import {fillHotels} from 'app/hotels';
import {fillList} from 'app/places';

// TODO: close mobile menu function
// TODO: better modules
// TODO: Detección de idioma inicial?

// Containers
let listPlaces = document.querySelector('#navbarNavUbicacionesSm'),
		listPlacesLg = document.querySelector('#navbarNavUbicacionesLg'),
		listHotelsSm = document.querySelector('#navbarNavHotelesSm'),
		listHotelsLgContainer = document.querySelector('#navbarNavHotelesLg'),
		menuContainerSm = document.querySelector('.navbar__bottom--container');
		
// Hotels & Places lists
let listPlacesEsp = [],
		listPlacesEng = [],
		hotelesEsp = [],
		hotelesEng = [];

// others
let groupEsp = L.layerGroup(),
		groupEng = L.layerGroup(),
		titleEsp = "",
		titleEng = "",
		menuEsp = [],
		menuEng = [];


// Create the map
let map = new L.map('map', {
	layers: [layers[currentHotel]],
	center: [0, 0],
	zoom: 0,
	maxBounds: new L.LatLngBounds(new L.LatLng(80, -250), new L.LatLng(-80, 250)),
	maxBoundsViscosity: 1.0
});
map.attributionControl.setPrefix("")


// Fill data
///
titleEsp = dataHoteles[currentHotel].nameEsp
titleEng = dataHoteles[currentHotel].nameEng
if (currentLang === "esp") {
	document.querySelector(".navbar--title").innerText = titleEsp
} else {
	document.querySelector(".navbar--title").innerText = titleEng
}

// menu
dataMenu.forEach(item => {
	let itemEsp = item.esp
	let itemEng = item.eng
	
	menuEsp.push(itemEsp)
	menuEng.push(itemEng)
})

// hoteles
for (const hotel in dataHoteles) {
	let hotelEsp = `<a class="navbar__item" href="${dataHoteles[hotel].url}">${dataHoteles[hotel].nameEsp}</a>`
	let hotelEng = `<a class="navbar__item" href="${dataHoteles[hotel].url}">${dataHoteles[hotel].nameEng}</a>`
	
	hotelesEsp += hotelEsp
	hotelesEng += hotelEng
}

if (currentLang === "esp") {
	fillHotels(listHotelsSm,hotelesEsp)
	fillHotels(listHotelsLgContainer,hotelesEsp)
} else {
	fillHotels(listHotelsSm,hotelesEsp)
	fillHotels(listHotelsLgContainer,hotelesEng)
}

listHotelsSm.querySelectorAll(".navbar__item").forEach(function(e) {
	if (e.href.includes(currentHotel)) {
		e.classList.add("active")
	} else {
		e.classList.remove("active")
	}
})
listHotelsLgContainer.querySelectorAll(".navbar__item").forEach(function(e) {
	if (e.href.includes(currentHotel)) {
		e.classList.add("active")
	} else {
		e.classList.remove("active")
	}
})

// lugares
dataHoteles[currentHotel]["locations"].forEach(place => {
	let markerEsp = L.marker( [place["lat"], place["lng"]], {
		icon: icon[place["cat"]]
	})
	.bindPopup(customPopup(place, "esp"),customOptions);
	
	let markerEng = L.marker( [place["lat"], place["lng"]], {
		icon: icon[place["cat"]]
	})
	.bindPopup(customPopup(place, "eng"),customOptions);
	
	// Add each marker to the group
	groupEsp.addLayer( markerEsp );
	groupEng.addLayer( markerEng );
	
	// Save the ID of the marker with it's data
	place.markerEsp_id = groupEsp.getLayerId(markerEsp);
	place.markerEng_id = groupEsp.getLayerId(markerEng);
})

if (currentLang === "esp") {
	groupEsp.addTo(map)
} else {
	groupEng.addTo(map)
}


// Click handler for handling
function onClickMenuItem(data) {
	let marker;
	
	if (currentLang === "esp") {
		marker = groupEsp.getLayer(data)
	} else {
		marker = groupEng.getLayer(data)
	}
	
	map.flyTo(marker.getLatLng(), 3)
	marker.openPopup()
	
	if(MobDet){
		// Close mobile menu, activate map
		let currentActiveMenu = document.querySelector(".active")
		currentActiveMenu.classList.remove("active")
		const activateMap = navBtnsSmContainer.querySelector(".navbar__bottom--item")
		activateMap.classList.add("active")
		const currentActiveBox = navSmContainer.querySelector(".show")
		if(currentActiveBox !== null) currentActiveBox.classList.remove("show")
	}
}


// Append list lugares
dataHoteles[currentHotel]["locations"].forEach(place => {
	let itemEsp = document.createElement('div')
	let itemEng = document.createElement('div')
	itemEsp.classList.add("navbar__item")
	itemEng.classList.add("navbar__item")
	
	itemEsp.innerHTML= `<button role="button">${place.lang.esp.name}${place.lang.esp.info ? `<small class="d-block">${place.lang.esp.info}</small>` : ``}</button>`
	itemEng.innerHTML= `<button role="button">${place.lang.eng.name}${place.lang.eng.info ? `<small class="d-block">${place.lang.eng.info}</small>` : ``}</button>`
	
	itemEsp.addEventListener("click", onClickMenuItem.bind(null, place.markerEsp_id))
	itemEng.addEventListener("click", onClickMenuItem.bind(null, place.markerEng_id))
	
	listPlacesEsp.push(itemEsp)
	listPlacesEng.push(itemEng)
	
})
if (currentLang === "esp") {
	if(MobDet){
		fillList(listPlaces,listPlacesEsp)
	} else {
		fillList(listPlacesLg,listPlacesEsp)
	}
} else {
	if(MobDet){
		fillList(listPlaces,listPlacesEng)
	} else {
		fillList(listPlacesLg,listPlacesEng)
	}
}


function changeMenuLang(menu) {
	menuContainerSm.querySelectorAll(".navbar__bottom--item").forEach((item, index) => {
		item.querySelector("span").textContent = menu[index]
	})
}

// Lang
///
const langContainer = document.querySelector(".navbar__idioma")
const langBtns = langContainer.querySelectorAll(".btn__lang")
const navbarNavLangLg = document.querySelector("#navbarNavLangLg")
const navbarNavLangSm = document.querySelector("#navbarNavLang")

if(!MobDet){ // set selected lang for desktop
	if (currentLang === "esp") {
		navbarNavLangLg.options.selectedIndex = 0
	} else {
		navbarNavLangLg.options.selectedIndex = 1
	}
} else {
	if (currentLang === "esp") {
		navbarNavLangSm.querySelectorAll(".navbar__item")[0].classList.add("active")
	} else {
		navbarNavLangSm.querySelectorAll(".navbar__item")[1].classList.add("active")
	}
}

function changeLanguage(btnLang) {
	let newLang;
	if(MobDet){
		newLang = btnLang.dataset.lang
	} else {
		newLang = navbarNavLangLg.options[navbarNavLangLg.selectedIndex].value		
	}
	
	if(currentLang === newLang) return
	
	// remove list of places
	while (listPlaces.firstChild) listPlaces.removeChild(listPlaces.firstChild)
	while (listPlacesLg.firstChild) listPlacesLg.removeChild(listPlacesLg.firstChild)
	
	// remove list of hotels
	while (listHotelsSm.firstChild) listHotelsSm.removeChild(listHotelsSm.firstChild)
	while (listHotelsLgContainer.firstChild) listHotelsLgContainer.removeChild(listHotelsLgContainer.firstChild)
	
	// add new list of places
	if (newLang === "esp") {
		createCookie("lang", "esp", 365)
		map.removeLayer(groupEng)
		groupEsp.addTo(map)
		
		if(MobDet){
			fillList(listPlaces,listPlacesEsp)
			document.querySelector(".navbar--title").innerText = titleEsp
			navbarNavLangSm.querySelectorAll(".navbar__item")[0].classList.add("active")
			navbarNavLangSm.querySelectorAll(".navbar__item")[1].classList.remove("active")
		} else {
			fillList(listPlacesLg,listPlacesEsp)
		}
		
		fillHotels(listHotelsSm,hotelesEsp) //mobile hotels
		fillHotels(listHotelsLgContainer,hotelesEsp) // desktop hotels
	}
	else if (newLang === "eng") {
		createCookie("lang", "eng", 365)
		map.removeLayer(groupEsp)
		groupEng.addTo(map)
		
		if(MobDet){
			fillList(listPlaces,listPlacesEng)
			document.querySelector(".navbar--title").innerText = titleEng
			navbarNavLangSm.querySelectorAll(".navbar__item")[0].classList.remove("active")
			navbarNavLangSm.querySelectorAll(".navbar__item")[1].classList.add("active")
		} else {
			fillList(listPlacesLg,listPlacesEng)
		}
		
		fillHotels(listHotelsSm,hotelesEng) //mobile hotels
		fillHotels(listHotelsLgContainer,hotelesEng) // desktop hotels
	}
	
	// active hotel
	listHotelsSm.querySelectorAll(".navbar__item").forEach(function(e) {
		if (e.href.includes(currentHotel)) {
			e.classList.add("active")
		} else {
			e.classList.remove("active")
		}
	})
	listHotelsLgContainer.querySelectorAll(".navbar__item").forEach(function(e) {
		if (e.href.includes(currentHotel)) {
			e.classList.add("active")
		} else {
			e.classList.remove("active")
		}
	})
	
	currentLang = newLang
	
	// Close mobile menu, activate map
	let currentActiveMenu = document.querySelector(".active")
	currentActiveMenu.classList.remove("active")
	const activateMap = navBtnsSmContainer.querySelector(".navbar__bottom--item")
	activateMap.classList.add("active")
	const currentActiveBox = navSmContainer.querySelector(".show")
	if(currentActiveBox !== null) currentActiveBox.classList.remove("show")
}

navbarNavLangLg.addEventListener("change", () => changeLanguage() );

langBtns.forEach(btnLang => {
	btnLang.addEventListener("click", function(e) {
		e.preventDefault();
		changeLanguage(btnLang)
	})
})

// Menú SM
///////////
const navBtnsSmContainer = document.querySelector(".navbar__bottom--container")
const navAnchor = navBtnsSmContainer.querySelectorAll(".navbar__bottom--item")

const navSmContainer = document.querySelector(".navbar__nav")
const nav = navBtnsSmContainer.querySelectorAll(".navbar__box")

navAnchor.forEach(anchor => {
	anchor.addEventListener("click", function(e) {
		e.preventDefault()
		
		// si ya está activo, no hagas nada
		if(this.classList.contains("active")) return
		
		// agregar activo
		const current = document.querySelector(".active")
		current.classList.remove("active")
		
		this.classList.add("active")
		
		
		// cajon de menu
		if(this.dataset.menu === "mapa") {
			const current = navSmContainer.querySelector(".show")
			current.classList.remove("show")
		}
		else if(this.dataset.menu) {
			const current = navSmContainer.querySelector(".show")
			
			if(current !== null) current.classList.remove("show")
			// current.style.display = "none";
			
			const currentMenu = navSmContainer.querySelector(`#${this.dataset.menu}`)
			currentMenu.classList.add("show")
	
		}
	})
})

// Galeria
const pswpElement = document.querySelectorAll('.pswp')[0];
var itemsPswp;
const options = {
	index: 0,
	shareEl: false,
	fullscreenEl: false
};
var gallery;

document.querySelector(".leaflet-popup-pane").addEventListener("click", function(e) {
	if(e.target.classList.contains("popup__btn")) {
		itemsPswp = [{
			src: `assets/images/thumbs/${currentHotel}/${e.target.dataset.placeid}_f.jpg`,
			w: e.target.dataset.imgw,
			h: e.target.dataset.imgh
		}]
		
		gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, itemsPswp, options);
		
		gallery.init()
	}
});